import React from 'react'
import ReactLeafletGoogleLayer from 'react-leaflet-google-layer'

const MapTileLayer: React.FC = () => (
  <ReactLeafletGoogleLayer type='roadmap'
    useGoogMapsLoader={false}
    styles={[
      {
        featureType: 'poi',
        stylers: [
          { visibility: 'off' }
        ]
      }
		]}
  />
)

export default MapTileLayer
